// Global styles
import './src/styles/global.css'

// element.scrollIntoView polyfill
import 'intersection-observer'
import smoothscroll from 'smoothscroll-polyfill'

smoothscroll.polyfill()
